import "./TabSwitcher.css";

export default function TabSwitcher({
  currentView,
  setCurrentView,
  mode = "calendar",
}) {
  const getViewOptions = (mode) => {
    switch (mode) {
      case "calendar":
        return [
          { label: "Weekly", value: "weekly" },
          { label: "Monthly", value: "monthly" },
        ];
      case "live":
        return [
          { label: "All Vehicles", value: "all" },
          { label: "Vehicles in Motion", value: "ongoing" },
        ];
      default:
        return [];
    }
  };

  const viewOptions = getViewOptions(mode);

  const handleClick = (e, view) => {
    e.preventDefault();
    setCurrentView(view);
  };

  return (
    <div className="view-tab-container" style={{ display: "flex" }}>
      {viewOptions.map((option, index) => {
        const isSelected = currentView === option.value;
        const isFirst = index === 0;
        const isLast = index === viewOptions.length - 1;

        return (
          <button
            key={option.value}
            type="button"
            onClick={(e) => handleClick(e, option.value)}
            className="view-tab-button"
            style={{
              borderTopLeftRadius: isFirst ? "0.5rem" : 0,
              borderBottomLeftRadius: isFirst ? "0.5rem" : 0,
              borderTopRightRadius: isLast ? "0.5rem" : 0,
              borderBottomRightRadius: isLast ? "0.5rem" : 0,
              backgroundColor: isSelected ? "#F9FAFB" : undefined,
            }}
          >
            <div className="view-tab-text">{option.label}</div>
          </button>
        );
      })}
    </div>
  );
}
